import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import Card from '../../core/components/Card'
import LoaderButton from '../../core/components/LoaderButton'
import ContactSelector from '../../provider/components/ContactSelector'
import ContactSuggestSelector from '../../provider/components/ContactSuggestSelector'
import ProviderSuggestSelector from '../../provider/components/ProviderSuggestSelector'
import {queryOpeningTicketPurposeRef} from '../../reference/actions'
import {IdentifyAssigneeCmd} from '../models'
import {IDENTIFY_ASSIGNEE_CMD_UPDATED, sendIdentifyAssigneeCmd, loadTicket} from '../actions'
import i18n from '../i18n'
import style from './IdentifyAssigneeCard.less'

class IdentifyAssignCard extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            ticketActivities: [],
            availableSelectors: [],
            displayedSelectors: []
        }
    }

    componentWillMount() {
        const {dispatch, ticket} = this.props   
        dispatch(queryOpeningTicketPurposeRef(ticket.linkedEntities.clientCompany.uid))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openingTicketPurposeReference != this.props.openingTicketPurposeReference
            || nextProps.ticket != this.props.ticket) {
            const {openingTicketPurposeReference, ticket, _providerLinks} = nextProps

            const ticketIncidentType = openingTicketPurposeReference.openingTicketPurposes.find((otp) => otp.uid == ticket.openingTicketPurpose.callPurposeUid)
            const ticketActivities = ticketIncidentType && ticketIncidentType.activities || []

            const availableSelectors = []
            if (ticket.linkedEntities.patrimony && ticket.openingTicketPurpose.callPurposeUid) availableSelectors.push('ContactSuggestSelector')
            if (ticket.linkedEntities.patrimony && ticketActivities.length > 0 && _providerLinks.find(linkFinder('suggest'))) availableSelectors.push('ProviderSuggestSelector')
            availableSelectors.push('ContactSelector')
            const displayedSelectors = availableSelectors.slice(0, 2)

            this.setState({ticketActivities, availableSelectors, displayedSelectors})
        }
    }

    _sendCmd = () => {
        const {dispatch} = this.props

        return dispatch(sendIdentifyAssigneeCmd()).then(() => {
            return dispatch(loadTicket())
        })
    }

    _confirmCmd = () => {
        this._closeModalEmptyInstructionModal()
        return this._sendCmd()
    }

    _sendCmdProxy = () => {
        const {form} = this.props
        if (form.instructions() && !form.instructions().value) {
            this.setState({
                openConfirmEmptyInstructionModal: true
            })
            return true
        } else {
            return this._sendCmd()
        }
    }

    _closeModalEmptyInstructionModal = () => {
        this.setState({openConfirmEmptyInstructionModal: false})
    }


    _renderModal() {
        return (<Modal
            className='modal-danger'
            show={true}
            onHide={this._closeModalEmptyInstructionModal}>
            <Modal.Header>
                <Modal.Title>Confirmer l'absence d'instruction</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={style.text}>
                    <p>Aucune instruction n'a été ajoutée à destination du fournisseur. Etes-vous sûr de vouloir continuer ?</p>
                </div>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='danger'
                        bsSize='large'
                        onClick={this._confirmCmd}>
                        {i18n.identifyAssignee}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={this._closeModalEmptyInstructionModal}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Modal.Body>
        </Modal>)
    }

    _match(event) {
        const fullTextTyped = event.target.value || null
        this.setState({fullTextTyped})
    }

    _search(event) {
        const {fullTextTyped} = this.state
        this.setState({fullText: fullTextTyped})
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {            
            const {fullTextTyped} = this.state
            event.preventDefault()
            this.setState({fullText: fullTextTyped})
        }
    }    

    _toggleDisplayedSelectors(event, show, hide) {
        const {availableSelectors, displayedSelectors} = this.state

        event.preventDefault()

        const showAvailableIndex = availableSelectors.indexOf(show)
        const hideDisplayedIndex = displayedSelectors.indexOf(hide)

        var nextDisplayedSelectors = [...displayedSelectors]
        if (showAvailableIndex >= 0 && hideDisplayedIndex >= 0) {
            nextDisplayedSelectors.splice(hideDisplayedIndex, 1)
            nextDisplayedSelectors.push(show)
        }

        this.setState({displayedSelectors: nextDisplayedSelectors})
    }

    render() {
        const {dispatch, openingTicketPurposeReference, form, cmd, ticket, patrimony, _providerLinks, ...others} = this.props
        const {fullText, ticketActivities, availableSelectors, displayedSelectors} = this.state

        const header = (
            <h5>{i18n.identifyAssignee}</h5>
        )

        const searchProviderButton = (
            <Button
                onClick={() => this._search()}>
                <Icon icon='search' size='xs' />
            </Button>
        )

        const referencedProviderContactField = (field) => {
            const value = field.value && field.value.providerUid

            const onChange = (contact) => {
                const assignee = {
                    assigneeType: 'ReferencedProviderContact',
                    providerUid: contact
                }
                field.onChange(assignee)
            }

            return {...field, value, onChange}
        }

        const referencedProviderCompanyField = (field) => {
            const value = field.value && field.value.providerUid

            const onChange = (contact) => {
                const assignee = {
                    assigneeType: 'ReferencedProviderCompany',
                    providerUid: contact
                }
                field.onChange(assignee)
            }

            return {...field, value, onChange}
        }

        return (
            <div className={style.default}>
                <Card
                    header={header}
                    {...others}>
                    <Row className='no-gutter'>
                        {availableSelectors.indexOf('ContactSuggestSelector') >= 0 && (
                            <div className={cx(style.visibility, {[style.visible]: displayedSelectors.indexOf('ContactSuggestSelector') >= 0})}>
                                <Col sm={6}>
                                    <div className={style.main}>
                                        <h5>
                                            <span>{i18n.patrimonyProviderContacts}</span>
                                            {availableSelectors.indexOf('ContactSelector') >= 0 && displayedSelectors.indexOf('ContactSelector') < 0 && (
                                                <a
                                                    href=''
                                                    onClick={(e) => this._toggleDisplayedSelectors(e, 'ContactSelector', 'ContactSuggestSelector')}>
                                                    {i18n.otherProviderContactsz}
                                                </a>
                                            )}
                                        </h5>
                                        <ContactSuggestSelector
                                            company={ticket.linkedEntities.clientCompany}
                                            patrimony={ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && patrimony || ticket.linkedEntities.patrimony}
                                            incidentType={ticket.openingTicketPurpose.callPurposeUid}
                                            disable={(c) => c.uid == (ticket.assignee && ticket.assignee.uid)}
                                            {...referencedProviderContactField(form.assignee())} />
                                    </div>
                                </Col>
                            </div>
                        )}
                        {availableSelectors.indexOf('ContactSelector') >= 0 && (
                            <div className={cx(style.visibility, {[style.visible]: displayedSelectors.indexOf('ContactSelector') >= 0})}>
                                <Col sm={displayedSelectors.length == 2 && 6 || 12}>
                                    <div className={style.main}>
                                        {displayedSelectors.length == 2 && (
                                            <h5>
                                                <span>{i18n.otherProviderContacts}</span>
                                                {availableSelectors.indexOf('ContactSuggestSelector') >= 0 && displayedSelectors.indexOf('ContactSuggestSelector') < 0 && (
                                                    <a
                                                        href=''
                                                        onClick={(e) => this._toggleDisplayedSelectors(e, 'ContactSuggestSelector', 'ContactSelector')}>
                                                        {i18n.patrimonyProviderContactsz}
                                                    </a>
                                                )}
                                            </h5>
                                        )}
                                        <ContactSelector
                                            kind='checkbox'
                                            company={ticket.linkedEntities.clientCompany}
                                            {...referencedProviderContactField(form.assignee())} />
                                    </div>
                                </Col>
                            </div>
                        )}
                        {availableSelectors.indexOf('ProviderSuggestSelector') >= 0 && (
                            <div className={cx(style.visibility, {[style.visible]: displayedSelectors.indexOf('ProviderSuggestSelector') >= 0})}>
                                <Col sm={6}>
                                    <div className={style.main}>
                                        <h5>{i18n.activityProviderCompanies}</h5>
                                        <ProviderSuggestSelector
                                            company={ticket.linkedEntities.clientCompany}
                                            patrimony={ticket.linkedEntities.patrimony.uid == (patrimony && patrimony.uid) && patrimony || ticket.linkedEntities.patrimony}
                                            activities={ticketActivities}
                                            disable={(p) => p.uid == (ticket.assignee && ticket.assignee.uid)}
                                            {...referencedProviderCompanyField(form.assignee())} />
                                    </div>
                                </Col>
                            </div>
                        )}
                    </Row>
                    {this.state.openConfirmEmptyInstructionModal && this._renderModal()}
                    <form>
                        <Input
                            type='textarea'
                            rows={4}
                            placeholder={i18n.instructionsForAssignee}
                            {...form.instructions()} />
                        <Input
                            type='textarea'
                            placeholder={i18n.comment}
                            {...form.comment()} />
                    </form>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmdProxy() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.identifyAssignee}
                        </LoaderButton>
                    </ButtonToolbar>
                </Card>
            </div>
        )
    }
}

IdentifyAssignCard = connectForm({
    target: 'cmd',
    schema: IdentifyAssigneeCmd.schema,
    action: IDENTIFY_ASSIGNEE_CMD_UPDATED
})(IdentifyAssignCard)

IdentifyAssignCard = connect((state) => ({
    openingTicketPurposeReference: state.reference.openingTicketPurposeRef,
    cmd: state.ticket.identifyAssigneeCmd,
    ticket: state.ticket.ticket,
    patrimony: state.patrimony.patrimony,
    _providerLinks: state.provider._links
}))(IdentifyAssignCard)

export default IdentifyAssignCard


// WEBPACK FOOTER //
// ./lib/ticket/components/IdentifyAssigneeCard.js